"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
function buildExpandingFormset(prefix, opts) {
    if (opts === void 0) { opts = {}; }
    var addButton = jquery_1["default"]('#' + prefix + '-ADD');
    var formContainer = jquery_1["default"]('#' + prefix + '-FORMS');
    var totalFormsInput = jquery_1["default"]('#' + prefix + '-TOTAL_FORMS');
    var formCount = parseInt(totalFormsInput.val(), 10);
    if (opts.onInit) {
        for (var i = 0; i < formCount; i++) {
            opts.onInit(i);
        }
    }
    var emptyFormTemplate = document.getElementById(prefix + '-EMPTY_FORM_TEMPLATE');
    if (emptyFormTemplate.innerText) {
        emptyFormTemplate = emptyFormTemplate.innerText;
    }
    else if (emptyFormTemplate.textContent) {
        emptyFormTemplate = emptyFormTemplate.textContent;
    }
    // eslint-disable-next-line consistent-return
    addButton.on('click', function () {
        if (addButton.hasClass('disabled'))
            return false;
        var newFormHtml = emptyFormTemplate
            .replace(/__prefix__(.*?['"])/g, formCount + '$1')
            .replace(/<-(-*)\/script>/g, '<$1/script>');
        formContainer.append(newFormHtml);
        if (opts.onAdd)
            opts.onAdd(formCount);
        if (opts.onInit)
            opts.onInit(formCount);
        formCount++;
        totalFormsInput.val(formCount);
    });
}
window.buildExpandingFormset = buildExpandingFormset;
